

import React, { useEffect, useState } from "react";
import "./MobileSlider.css";
import "./ScienceAndTechSlider.css"
import { Select } from "antd";
import { Citys, cities, location1 } from "../../component/Location";
import { Mobiles } from "../../component/env";
import { isMobile } from "react-device-detect";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { getExtraField } from "../../store/ProductFilterSlice";
const images = [
    "https://thumbs.dreamstime.com/b/padlock-chain-electronic-printed-circuit-board-internet-protection-computer-safety-network-security-data-security-132582466.jpg",
    "https://wallpapercave.com/wp/wp7021955.jpg",
    "https://wallpaperaccess.com/full/10279135.jpg",
    "https://th.bing.com/th/id/OIP.Pf-Ucp-Ri1TgDjOdriVOLQHaE9?rs=1&pid=ImgDetMain",
    "https://th.bing.com/th/id/OIP.q3UJpmdStGWRG_M8ZtmzBQHaEo?rs=1&pid=ImgDetMain",
    "https://thumbs.dreamstime.com/z/safety-data-protection-network-security-safe-concept-67245967.jpg",
    "https://c4.wallpaperflare.com/wallpaper/370/237/302/cctv-camera-security-wallpaper-preview.jpg"
];

const SecurityAndSafetySlider = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [visible1, setVisible1] = useState(false);
    const handleDropdownVisibleChange = (open) => {
        setVisible1(open);
    };
    const [visible2, setVisible2] = useState(false);
    const handleDropdownVisibleChange2 = (open) => {
        setVisible2(open);
    };
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 2000);
        return () => clearInterval(interval);
    }, [images.length]);

    const mobilestyle = {
        height: "200px",
        width: "100%",
    };
    const desktopstyle = {
        height: "340px",
        width: "90%",
        marginLeft: "1.5cm",
        marginRight: "2.5cm",
        borderRadius: "20px",
    };
    const mobstyle = {
        display: "flex",
        flexDirection: "column",
    };
    const deskstyle = {
        display: "flex",
        flexDirection: "row",
    };

    const [selectedFilter, setSelectedFilter] = useState(null);

    const [loading, setLoading] = useState(false); // Setting up a state variable 'loading' and its setter function 'setLoading' with initial value 'false'
    const disptach = useDispatch();
    const dispatch = useDispatch();
    // Accessing the Redux dispatch function
    const [errorMessage, setErrorMessage] = useState(null);
    const [extraFieldCopy, setExtraFieldCopy] = useState({});
    const [city, setCity] = useState();
    const [category, setCategory] = useState();
    const [cityError, setCityError] = useState("");
    const [categoryError, setCategoryError] = useState("");
    const [searchSending, setsearchSending] = useState({
        subCategoryType: null,
        subCategoryValue: null,
        City: null,
        searchValue: null,
        category: "ScienceAndTech",
        minPrice: null,
        maxPrice: null,
    }); // State for search form data

    //   const disptach = useDispatch(); // Initializing useDispatch hook

    // Event handler for input field changes
    const handleChange = (e) => {
        var name = e.target.name;
        var value = e.target.value;
        setExtraFieldCopy({ [name]: value });
        // setsearchSending({ ...searchSending, [name]: value });
        // disptach(getExtraField(searchSending)); // Dispatching getExtraField action
    };

    useEffect(() => {
        // Update searchSending state with the selected filter value
        if (selectedFilter !== null) {
            setsearchSending((prevState) => ({
                ...prevState,
                category: selectedFilter,
            }));
        }
    }, [selectedFilter]);
    return (
        <>
            <div
                className="scienceslide scienceslide-awi-24 mt-4 mb-3"
            // style={isMobile ? mobstyle : deskstyle}
            >

                <div className="carousel-innerscience24-awi-24">
                    {images.map((image, index) => (
                        <div
                            key={index}
                            className={`carousel-item${index === activeIndex ? " active" : ""
                                }`}
                        >
                            <img
                                src={image}
                                alt={`Slide ${index}`}
                                style={isMobile ? mobilestyle : desktopstyle}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default SecurityAndSafetySlider ;
